require('./DashboardModalTaskCollapsibleItemAmountSmall.scss');

const React = require('react'),
    AppDispatcher = require('dispatcher/SchedulerAppDispatcher'),
    {t} = require('services/i18nextWrapper'),
    { PropTypes } = require('react'),
    { map, find, filter, some } = require('lodash/collection'),
    get = require('lodash/object').get,
    InventoryStore = require('stores/InventoryStore'),
    NumberUtils = require('utils/NumberUtils'),
    ActionTypes = require('constants/AppConstants').ActionTypes,
    DashboardServiceCache = require('services/DashboardServiceCache'),
    ContentUtils = require('utils/ContentUtils'),
    Chips = require('components/Chips/Chips'),

    { TextField, FontIcon, IconButton} = require('material-ui');

const DashboardModalTaskCollapsibleItemAmountSmall = React.createClass({displayName: "DashboardModalTaskCollapsibleItemAmountSmall",
    propTypes: {
        task: PropTypes.object,
        product: PropTypes.object,
        productItem: PropTypes.object,
        onChangeAmount: PropTypes.func,
        onChangeAmountInLocation: PropTypes.func,
        uniqueId: PropTypes.string,
        isConfirmed: PropTypes.string,
        amount: PropTypes.number
    },

    getInitialState() {
        return {
            isCollapsed: true,
            isEditMode: false,
            needConfirm: false,
            locationsAmountChanged: [],
            errors: []
        };
    },

    componentDidMount() {
        if (!this.isMounted()) { // avoid several problem of rendering when try to call 'refs' which are not mounted yet
            return;
        }
        const { amount } = this.props;
        this.refs.inputValue.setValue(NumberUtils.truncate(amount));
    },

    componentDidUpdate() {
        if (!this.isMounted()) { // avoid several problem of rendering when try to call 'refs' which are not mounted yet
            return;
        }
        const { amount } = this.props;
        this.refs.inputValue.setValue(NumberUtils.truncate(amount));
    },

    componentWillReceiveProps(nextProps) {
        if (!this.isMounted()) { // avoid several problem of rendering when try to call 'refs' which are not mounted yet
            return;
        }
        const { amount } = nextProps;
        this.refs.inputValue.setValue(NumberUtils.truncate(amount));
    },

    getLocationSubtractionNonEditable(productItem, locations, whereInventoryWasTaken) {
        const unit = get(productItem, 'unit');

        // filter location item with zero
        const whereInventoryWasTakenFiltered = filter(whereInventoryWasTaken, inventoryTaken =>
            !(get(inventoryTaken, 'type') === 'LOCATION_ITEM_MODULE' &&
              NumberUtils.isEqual(get(inventoryTaken, 'amountSubtracted') || '0', '0'))
        );

        return map(whereInventoryWasTakenFiltered, inventoryTaken => {
            const isFromStock =
                get(inventoryTaken, 'type') === 'LOCATION_ITEM_MODULE';
            const isVendorPurchaseItem =
                get(inventoryTaken, 'type') === 'VENDOR_PURCHASE_ITEM_MODULE';
            const isVendorPurchaseItemMissing =
                get(inventoryTaken, 'type') ===
                'VENDOR_PURCHASE_ITEM_MISSING_MODULE';

            if (isFromStock) {
                // is enough items or discount all and then
                const iconInfo = productItem.existItemInStock
                    ? { bgColor: '#0f9d58', icon: 'home' }
                    : { bgColor: '#db4437', icon: 'error' };

                const locationTarget = find(
                    locations,
                    location =>
                        get(location, 'id') ===
                        get(inventoryTaken, 'locationId')
                );
                const locationName = get(locationTarget, 'name') || '';
                const amount = NumberUtils.truncate(
                    get(inventoryTaken, 'amountSubtracted') || ''
                );
                const textShips = `${locationName} (${amount} ${unit})`;
                return (
                    React.createElement(Chips, {
                        className: productItem.existItemInStock ? 'enough-inventory' : 'not-enough-inventory', 
                        onClickLink: () => {
                            //AppDispatcher.dispatch({
                            //    type: ActionTypes.DASHBOARD_MODAL_CLOSE_MODAL
                            //});
                        }, 
                        icon: "home", 
                        bgColorIcon: iconInfo.bgColor, 
                        text: textShips}
                    )
                );
            } else if (isVendorPurchaseItem) {
                const iconInfo = productItem.isPurchased
                    ? { bgColor: '#fcca2e', icon: 'home' }
                    : { bgColor: '#db4437', icon: 'error' };

                const vendorPurchaseCode =
                    get(inventoryTaken, 'code') || '';
                const amount = NumberUtils.truncate(
                    get(inventoryTaken, 'amountSubtracted') || ''
                );
                const textShips = `PO #${vendorPurchaseCode} (${amount} ${unit})`;

                return (
                    React.createElement(Chips, {
                        className: productItem.isPurchased ? 'is-purchased' : 'not-enough-inventory', 
                        icon: "shopping_cart", 
                        bgColorIcon: iconInfo.bgColor, 
                        text: textShips}
                    )
                );
            } else if (isVendorPurchaseItemMissing) {
                const iconInfo = { bgColor: '#db4437', icon: 'error' };
                const amount = NumberUtils.truncate(
                    get(inventoryTaken, 'amountItemNeeded') || ''
                );
                const textShips = `${t('dashboard_modal_task_inline_error_need_purchase')} (${amount} ${unit})`;

                return (
                    React.createElement(Chips, {
                        className: "is-item-missing not-enough-inventory", 
                        icon: "shopping_cart", 
                        bgColorIcon: iconInfo.bgColor, 
                        text: textShips}
                    )
                );
            }
        });
    },

    onChangeAmountInLocation(location, whereInventoryWasTakenLocation, index, productItem, evt) {
        const {product, onChangeAmountInLocation} = this.props;
        
        // prevent to re-calculate inventory
        product.isNeededCalculateInventory = false;
        
        const locationId = get(location, 'id');
        const itemId = get(productItem, 'item.id');

        // get the current amount in stock
        const amountInStock = getAmountInStock(product, locationId, itemId);
        // the new amount to subtract in give location
        const newAmountLocationItem = evt.target.value;

        const isNotEnoughStock = NumberUtils.isGreater(newAmountLocationItem, amountInStock);

        if (isNotEnoughStock) {
            const errorMessage = `${t('dashboard_modal_task_inline_error_max_amount_from_this_location_is')} ${NumberUtils.truncate(amountInStock)}`;
            this.setState(prevState => {
                let errors = prevState.errors || [];
                // remove old error
                errors = filter(errors, error => get(error,'index') !== index);
                // add new one
                errors.push({index, errorMessage});
                return {
                    errors
                };
            });
        } else {

            const productItemUpdated = InventoryStore.onChangeAmountInLocation(productItem, newAmountLocationItem, locationId);
            onChangeAmountInLocation.bind(this, productItemUpdated)();

            this.setState(prevState => {
                let errors = prevState.errors || [];
                // remove old error
                errors = filter(errors, error => get(error,'index') !== index);
                return {
                    errors
                };
            });
        }
    },

    toggleEditMode() {
        this.setState(prevState => {
            return {
                isEditMode: !prevState.isEditMode,
                errors: [] // clean old errors
            };
        });
    },

    getLocationSubtractionEditable() {
        const { locations, productItem } = this.props;
        const sortedLocations = ContentUtils.sortListDesc(locations, 'id');
        const {errors} = this.state;
        const whereInventoryWasTaken = get(productItem, 'whereInventoryWasTakenNew');
        const itemId = get(productItem, 'item.id');
        const unit = get(productItem, 'item.unit');
        const whereInventoryWasTakenLocations = filter(whereInventoryWasTaken, whereWasTaken => get(whereWasTaken, 'type') === 'LOCATION_ITEM_MODULE');
        const haveLocationWasTaken = ContentUtils.isNotEmptyArray(whereInventoryWasTakenLocations);

        const locationEditEl = map(ContentUtils.filterEnable(sortedLocations), (location, index) => {
                const whereInventoryWasTakenLocation = haveLocationWasTaken ? find(whereInventoryWasTakenLocations,
                        inventoryInfo => get(inventoryInfo, 'locationId') === get(location, 'id') &&
                                         get(inventoryInfo, 'itemId') === itemId
                ) : null;

                const errorMessageText = get(find(errors, error => get(error, 'index') === index), 'errorMessage') || '';

            return (
                React.createElement("span", {"data-item-name": "", className: errorMessageText === '' ? 'dashboard-modal-item-small__item-input-small' : 'dashboard-modal-item-small__item-input-small is-error'}, 
                        React.createElement("small", {className: "location-name"}, `${get(location, 'name')} (${unit})`), 
                        React.createElement(TextField, {
                            className: "amount-name", 
                            onBlur: this.onChangeAmountInLocation.bind(this, location, whereInventoryWasTakenLocation, index, productItem), 
                            hintText: t('dashboard_modal_task_products_amount'), 
                            errorText: errorMessageText, 
                            defaultValue: get(whereInventoryWasTakenLocation, 'amountSubtracted') || '0', 
                            key: `input-small-${index}`, 
                            disabled: false}
                        )
                    )
            );
        });

        return (
            React.createElement("span", {className: "dashboard-modal-item-small__edit-location-content"}, 
                locationEditEl
            )
        );
    },
    
    textfieldAmountItem({
      styleInputs,
      uniqueId,
      isDisconfirmingPublishedProduct,
      isConfirmed,
      isEditMode,
      existSomeLocationToEdit,
      productItem,
      onChangeAmount,
      buttonToggleEditModoEl
    }) {
        return (
          React.createElement("div", {className: isConfirmed ? 'dashboard-modal-item-small__item is-confirmed' : 'dashboard-modal-item-small__item'}, 
          React.createElement("span", {
            className: "dashboard-modal-item-small__item-label text-right", 
            style: {
                display: 'inline !important',
                top: '7px',
                left: '12px'
            }
          }, 
                        `${get(productItem, 'description')} (${get(productItem, 'item.unit')})`
                    ), 
              React.createElement("span", {className: "dashboard-modal-item-small__item-input"}, 
                        React.createElement(TextField, {
                          onBlur: onChangeAmount.bind(this, productItem), 
                          ref: "inputValue", 
                          hintText: t('dashboard_modal_task_products_amount'), 
                          style: styleInputs, 
                          key: uniqueId, 
                          disabled: isDisconfirmingPublishedProduct || isConfirmed ? true : (isEditMode && existSomeLocationToEdit)}
                        )
                    ), 
              React.createElement("span", {className: "dashboard-modal-item-small__toggle-edit"}, 
                        buttonToggleEditModoEl
                    )
          )
        );
    },
    
    render() {
        const { productItem, uniqueId, onChangeAmount, locations, isConfirmed, product } = this.props;
        const sortedLocations = ContentUtils.sortListDesc(locations, 'id');
        const { isEditMode  } = this.state;
        const styleInputs = {
            marginTop: '-10px',
            height: '40px',
            lineHeight: '25px',
            width: 'initial'
        };

        // ask if have at least one item in location to edit
        // otherwise non needed the edit mode
        const existSomeLocationToEdit = some(get(productItem, 'whereInventoryWasTakenNew'), whereInventoryWasTaken => { return get(whereInventoryWasTaken, 'type') === 'LOCATION_ITEM_MODULE';});

        const isDisconfirmingPublishedProduct = !product.isConfirmed && product.isDiscounted;

        // check if item will need to subtract or add
        const isAddition = get(productItem, 'addition');
        const buttonToggleEditMode = isConfirmed ? null : (isEditMode ? (
                    React.createElement(IconButton, {onClick: this.toggleEditMode, className: "is-visibility-mode", touch: true}, 
                        React.createElement(FontIcon, {color: '#000000', className: "material-icons"}, "save")
                    )
                ) :
                (
                    React.createElement(IconButton, {onClick: this.toggleEditMode, className: "is-edit-mode", touch: true}, 
                        React.createElement(FontIcon, {color: '#000000', className: "material-icons"}, "mode_edit")
                    )
                )
        );

        const whereInventoryWasTaken = InventoryStore.retrieveLatestWhereInventoryWasTaken(productItem);

        // filter location item with zero
        const onlyItemMissing = get(whereInventoryWasTaken, 'length') === 1 &&
            get(whereInventoryWasTaken, '0.type') === 'VENDOR_PURCHASE_ITEM_MISSING_MODULE';


        const singleItem = get(whereInventoryWasTaken, 'length') === 1;

        const someItemPurchase = some(whereInventoryWasTaken, info => get(info, 'type') === 'VENDOR_PURCHASE_ITEM_MODULE');
        const withoutAnyStock = !some(whereInventoryWasTaken, info => get(info, 'type') === 'LOCATION_ITEM_MODULE');

         let extraItemClassName = '';

         if (onlyItemMissing) {
             extraItemClassName += ' is-all-item-missing';
         }

         if (singleItem) {
             extraItemClassName += ' is-single-item';
         }

         if (someItemPurchase) {
             extraItemClassName += ' is-some-item-purchase';
         }

         if (withoutAnyStock) {
             extraItemClassName += ' is-without-stock';
         }

        // show where need to subtract in case of the item are subtraction
        const locationsSubtractionInfoEl = isAddition || isDisconfirmingPublishedProduct
            ? null
            : (isEditMode && !isConfirmed) ?
                this.getLocationSubtractionEditable() :
                this.getLocationSubtractionNonEditable(productItem, sortedLocations, whereInventoryWasTaken);

        // only show when we have at least one location to adjust
        const buttonToggleEditModoEl = !isDisconfirmingPublishedProduct  ? buttonToggleEditMode : null;
    
        const textfieldAmountItemEl = this.textfieldAmountItem({
            styleInputs,
            uniqueId,
            isDisconfirmingPublishedProduct,
            isConfirmed,
            isEditMode,
            existSomeLocationToEdit,
            productItem,
            onChangeAmount,
            buttonToggleEditModoEl
        });
        
        return (
            React.createElement("li", {
                key: uniqueId, 
                "data-item-description": get(productItem, 'item.description'), 
                className: "dashboard-modal-item-small", 
                style: { listStyle: 'none'}
            }, 
                
                textfieldAmountItemEl, 
                
                React.createElement("div", {"data-item-description": get(productItem, 'item.description'), className: 'where-items-was-subtracted' + extraItemClassName}, 
                    locationsSubtractionInfoEl
                )
            )
        );
    }
});

function getAmountInStock(product, locationId, itemId) {
    // Calculate scope inventory again of each group of items & items
    let locationItemsAvailable = DashboardServiceCache.getLocationItems();
    const isUnconfirmedProductAlreadySaved = product.isConfirmed === false && product.isDiscounted;
    if (isUnconfirmedProductAlreadySaved) {
        // enter here means we need to simulate to return items to inventory in order to
        // calculate the new adjust of amount of items of the product
        locationItemsAvailable = InventoryStore.returnItemsConsumed(product, locationItemsAvailable);
    }

    const locationItemTarget = find(locationItemsAvailable, locationItem =>
                                    get(locationItem, 'location.id') === locationId &&
                                    get(locationItem, 'item.id') === itemId);

    // current existing stock in this location
    return get(locationItemTarget, 'amount') || '0';
}

module.exports = DashboardModalTaskCollapsibleItemAmountSmall;



/** WEBPACK FOOTER **
 ** ./src/components/DashboardModal/DashboardModalTask/DashboardModalTaskCollapsibleItemAmountSmall.jsx
 **/